import { ABOUT } from "@/data/content";
import { Compass, Target, Heart } from "lucide-react";

export default function VisionMission() {
  return (
    <section className="section-y bg-[var(--bg)] relative overflow-hidden" data-testid="home-vision-mission">
      <div className="absolute inset-0 opacity-40" style={{ backgroundImage: "radial-gradient(circle at 20% 20%, rgba(27,58,142,.05) 0%, transparent 40%)" }} />

      <div className="container-sf relative">
        <div className="grid lg:grid-cols-12 gap-8">
          {/* Left column - editorial intro */}
          <div className="lg:col-span-5 lg:sticky lg:top-28 lg:self-start">
            <div className="eyebrow mb-4">Mengapa Kami Ada</div>
            <h2 className="text-4xl md:text-5xl lg:text-[3.4rem] font-bold leading-[1.05] tracking-tight text-slate-900">
              Membangun{" "}
              <span className="font-serif-display italic font-normal text-[var(--brand-orange)]">ekosistem dampak</span>{" "}
              yang terintegrasi.
            </h2>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed">
              Tantangan pembangunan modern tidak dapat diselesaikan melalui pendekatan sektoral yang berdiri sendiri.
              Kami menghubungkan kemanusiaan, ketahanan pangan, kesehatan, pendidikan, ekonomi, lingkungan, dan inovasi dalam satu kerangka.
            </p>
            <div className="mt-8 flex items-center gap-4 text-sm text-slate-500">
              <div className="h-px w-12 bg-slate-300" />
              <span className="font-semibold uppercase tracking-widest">Impact Ecosystem Builder</span>
            </div>
          </div>

          {/* Right column - bento vision/mission */}
          <div className="lg:col-span-7 space-y-6">
            {/* Vision card */}
            <div className="card-sf p-8 md:p-10 relative overflow-hidden" data-testid="vision-card">
              <div className="absolute top-0 right-0 h-40 w-40 rounded-full bg-[var(--brand-blue)]/6" />
              <div className="relative flex items-start gap-4">
                <div className="h-12 w-12 rounded-xl bg-[var(--brand-blue)] text-white flex items-center justify-center shrink-0">
                  <Compass className="h-6 w-6" />
                </div>
                <div>
                  <div className="text-xs font-semibold uppercase tracking-wider text-[var(--brand-blue)]">Visi</div>
                  <h3 className="mt-1 text-2xl font-bold text-slate-900">Visi Kami</h3>
                </div>
              </div>
              <p className="relative mt-5 text-slate-700 leading-relaxed text-lg">
                {ABOUT.vision}
              </p>
            </div>

            {/* Mission list */}
            <div className="card-sf p-8 md:p-10" data-testid="mission-card">
              <div className="flex items-start gap-4 mb-6">
                <div className="h-12 w-12 rounded-xl bg-[var(--brand-orange)] text-white flex items-center justify-center shrink-0">
                  <Target className="h-6 w-6" />
                </div>
                <div>
                  <div className="text-xs font-semibold uppercase tracking-wider text-[var(--brand-orange)]">Misi</div>
                  <h3 className="mt-1 text-2xl font-bold text-slate-900">Tujuh Misi Utama</h3>
                </div>
              </div>
              <ol className="grid sm:grid-cols-2 gap-x-6 gap-y-4">
                {ABOUT.mission.map((m, i) => (
                  <li key={i} className="flex gap-3 group">
                    <span className="marker-num text-2xl leading-none w-8 shrink-0">0{i + 1}</span>
                    <span className="text-sm text-slate-600 leading-relaxed pt-1">{m}</span>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
